export const useMandateStyles = () => ({
  root: {
    width: '80%',
    margin: 'auto',
    paddingTop: '1rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  centeredText: {
    fontWeight: 'bold',
    fontSize: '14px',
    padding: 'auto',
  },
  speedometer: {
    marginTop: '1rem',
  },
  typo: {
    marginTop: '1rem',
  },
  panel: {
    padding: '1rem',
    overflow: 'auto',
  },
  speedometerGrid: {
    margin: '1rem',
    width: '50%',
  },
  justification: {
    marginTop: '2rem',
    marginBottom: '3rem',
  },
  submit: {
    marginLeft: 'auto',
    display: 'table',
  },
  cancel: {
    marginRight: '1rem',
  },
  mainATR: {
    height: '10rem',
    width: '17rem',
  },
  adviserSelect: {
    width: '66%',
    marginTop: '1rem',
    marginBottom: '1rem',
  },
  errorNotice: {
    marginTop: '1rem',
  },
});
